import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as authConsts from '../../../auth-constants';
import { SignupService } from '../../../service/signup.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class UpdatePasswordComponent implements OnChanges {

  @Input() authForm: any
  @Input() userProfile: any

  pass_strength_param = authConsts.pass_strength_param;
  pass_strength = authConsts.pass_strength;
  isSamepass = true;

  constructor(private readonly signUpService: SignupService,) { }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['authForm']?.currentValue) {
        setTimeout(() =>this.inp_pass({ target: { value: this.userProfile.pass } }), 300)
      }
  }

  getpassStrength(x: any) {
    if (x) return 'yes';
    return 'no';
  }
  inp_pass(e: any) {
    const inputValue = (e.target as HTMLInputElement)?.value;
    this.pass_strength_param.min8 = this.getpassStrength(inputValue?.length > 8);
    this.pass_strength_param.lower = this.getpassStrength(/(?=.*[a-z])/.test(inputValue));
    this.pass_strength_param.number = this.getpassStrength(/(?=.*\d)/.test(inputValue));
    this.pass_strength_param.upper = this.getpassStrength(/(?=.*[A-Z])/.test(inputValue));
    this.pass_strength_param.special = this.getpassStrength(/.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-].*/.test(inputValue));
    this.pass_strength_param.whiteSpace = this.getpassStrength(/^[\S]+.*[\S]+$/.test(inputValue));
    const isValidPassword = this.updateSubmit_doublepass()
    if (!isValidPassword) this.authForm.controls['password']?.setErrors({ 'criteriaNotMet': true })
    else this.authForm.controls['password']?.setErrors(null)
    this.inp_pass2()
  }

  inp_pass2() {
    this.isSamepass = this.userProfile.pass == this.userProfile.pass2;
    if (!this.isSamepass) this.authForm.controls['password2']?.setErrors({ 'passwordNotSame': true })
    else this.authForm.controls['password2']?.setErrors(null)
  }

  updateSubmit_doublepass() {
    return Object.values(this.pass_strength_param).every(value => value === 'yes');
  }
}
